module.exports = __webpack_public_path__ + "static/media/vcard-contact.9427bacb.svg";